const CHALLENGE_TYPE_SELECTORS = {
    common: [
        '#div_id_sources-0-docker_file',
        '#div_id_sources-0-disks_file',
        '#div_id_sources-0-git_url',
        '#info-disk-image',
        '#alert-random-flag',
        '#form-disk-file',
        '#info-no-source',
        '#div_id_sources-0-delete_disks_file'
    ],
    docker: [
        '#challenge-sources',
        '#div_id_sources-0-docker_file',
        '#div_id_sources-0-git_url',
        '#alert-random-flag'
    ],
    vm: [
        '#challenge-sources',
        '#div_id_sources-0-disks_file',
        '#info-disk-image',
        '#form-disk-file',
        '#div_id_sources-0-delete_disks_file'
    ],
    none: ['#info-no-source']
};

/**
 * Initializes challenge form type switcher
 */
export function init() {
    const sectionInfos = document.getElementById('section-infos');
    if (!sectionInfos) return;

    const challengeTypeSelect = document.querySelector('#id_challenge_type');
    if (!challengeTypeSelect) return;

    updateChallengeTypeVisibility(challengeTypeSelect.value, false);

    challengeTypeSelect.addEventListener('change', () => {
        updateChallengeTypeVisibility(challengeTypeSelect.value, true);
    });
}

/**
 * Updates visibility of form fields based on challenge type
 * @param {string} challengeType - The selected challenge type
 * @param {boolean} clearErrors - Whether to clear error messages
 */
function updateChallengeTypeVisibility(challengeType, clearErrors = true) {
    hideAllChallengeFields();

    if (clearErrors) {
        removeErrorMessages();
    }

    showFieldsForChallengeType(challengeType);
}

/**
 * Hides all challenge type specific fields
 */
function hideAllChallengeFields() {
    addClassToElements(CHALLENGE_TYPE_SELECTORS.common, 'hidden');
}

/**
 * Shows fields relevant to the selected challenge type
 */
function showFieldsForChallengeType(challengeType) {
    const selectorsMap = {
        'DOCKER': CHALLENGE_TYPE_SELECTORS.docker,
        'VM': CHALLENGE_TYPE_SELECTORS.vm
    };

    const selectors = selectorsMap[challengeType] || CHALLENGE_TYPE_SELECTORS.none;
    removeClassFromElements(selectors, 'hidden');
}

/**
 * Adds a CSS class to multiple elements
 */
function addClassToElements(selectors, className) {
    selectors.forEach(selector => {
        document.querySelectorAll(selector).forEach(element => {
            element.classList.add(className);
        });
    });
}

/**
 * Removes a CSS class from multiple elements
 */
function removeClassFromElements(selectors, className) {
    selectors.forEach(selector => {
        document.querySelectorAll(selector).forEach(element => {
            element.classList.remove(className);
        });
    });
}

/**
 * Removes error messages from challenge sources section
 */
function removeErrorMessages() {
    document.querySelectorAll('#challenge-sources .errorlist').forEach(errorList => {
        errorList.remove();
    });
}
